
import Vue from "vue"
import { mapActions } from "vuex"

export default Vue.extend({
  data: () => ({
    id: "",
    invalid: false,
    loading: false,
  }),

  computed: {
    error () {
      if (!this.invalid)
        return ""
      return this.$t("error.invalidId")
    },
  },

  watch: {
    id () {
      this.invalid = false
    },
  },

  methods: {
    ...mapActions("user", { setAccDeletion: "SET_ACCOUNT_DELETION" }),

    async onSubmit () {
      this.invalid = false
      this.loading = true

      const [res, err] = await this.$api.user
        .createUserDeleteRequest({
          deleteReason: "OTHER_ACCOUNT",
          secondUser: this.id,
        })

      if (err || !res) {
        console.error(err || this.$t("unknownError"))
        this.invalid = true
        this.loading = false
        return
      }

      this.loading = false
      this.setAccDeletion(res)
      this.$emit("close")
    },
  },
})
